import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    Divider,
    DrawerBody,
    DrawerContainer,
    DrawerOverlay,
    DrawerContent,
    Flex,
    Icon,
} from '@spothero/ui';
import IconMenu from '@spothero/icons/menu';

import MobileNavigationHeader from './MobileNavigationHeader';
import MobileUserMenu from '../user-menu/MobileUserMenu';
import MobileNavigationItem from './MobileNavigationItem';

const MobileNavigationMenu = ({
    handleNavigationMenuToggle,
    isNavigationMenuOpen,
    navigationRoutes,
}) => {
    const [isRatesMenuOpen, setIsRatesMenuOpen] = useState(false);
    const [isFacilitiesMenuOpen, setIsFacilitiesMenuOpen] = useState(false);
    const [isAccountingMenuOpen, setIsAccountingMenuOpen] = useState(false);
    const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
    const [isReservationsMenuOpen, setIsReservationsMenuOpen] = useState(false);

    const handleReservationsMenuToggle = () => {
        setIsFacilitiesMenuOpen(false);
        setIsAccountingMenuOpen(false);
        setIsRatesMenuOpen(false);
        setIsReservationsMenuOpen((prevState) => !prevState);
    };

    const handleRatesMenuToggle = () => {
        setIsFacilitiesMenuOpen(false);
        setIsAccountingMenuOpen(false);
        setIsReservationsMenuOpen(false);
        setIsRatesMenuOpen((prevState) => !prevState);
    };

    const handleFacilitiesMenuToggle = () => {
        setIsRatesMenuOpen(false);
        setIsAccountingMenuOpen(false);
        setIsReservationsMenuOpen(false);
        setIsFacilitiesMenuOpen((prevState) => !prevState);
    };

    const handleAccountingMenuToggle = () => {
        setIsRatesMenuOpen(false);
        setIsFacilitiesMenuOpen(false);
        setIsReservationsMenuOpen(false);
        setIsAccountingMenuOpen((prevState) => !prevState);
    };

    const handleAccountMenuToggle = () => {
        setIsRatesMenuOpen(false);
        setIsFacilitiesMenuOpen(false);
        setIsAccountingMenuOpen(false);
        setIsReservationsMenuOpen(false);
        setIsAccountMenuOpen((prevState) => !prevState);
    };

    const handleSubMenuCloseClick = () => {
        setIsRatesMenuOpen(false);
        setIsFacilitiesMenuOpen(false);
        setIsAccountingMenuOpen(false);
        setIsAccountMenuOpen(false);
        setIsReservationsMenuOpen(false);
        handleNavigationMenuToggle();
    };

    const handleMenuItemClick = () => {
        setIsRatesMenuOpen(false);
        setIsFacilitiesMenuOpen(false);
        setIsAccountingMenuOpen(false);
        setIsReservationsMenuOpen(false);
        handleNavigationMenuToggle();
    };

    const handleSubMenuToggle = (label) =>
        label === 'Rates & Inventory'
            ? handleRatesMenuToggle
            : label === 'Facility Information'
              ? handleFacilitiesMenuToggle
              : label === 'Reservations'
                ? handleReservationsMenuToggle
                : handleAccountingMenuToggle;

    const isSubMenuOpen = (label) =>
        label === 'Rates & Inventory'
            ? isRatesMenuOpen
            : label === 'Facility Information'
              ? isFacilitiesMenuOpen
              : label === 'Reservations'
                ? isReservationsMenuOpen
                : isAccountingMenuOpen;

    return (
        <>
            <Button
                onClick={handleNavigationMenuToggle}
                variant="tertiary"
                flexDirection="column"
                gap={1}
                height={12}
                width={20}
                fontSize="xs"
                color="black"
                borderRadius="base"
            >
                <Icon as={IconMenu} boxSize={6} />
                Menu
            </Button>
            <DrawerContainer
                isOpen={isNavigationMenuOpen}
                onClose={handleNavigationMenuToggle}
                blockScrollOnMount
                placement="right"
                size="full"
            >
                <DrawerOverlay />
                <DrawerContent>
                    <MobileNavigationHeader />
                    <DrawerBody>
                        <Flex
                            direction="column"
                            gap={4}
                            justifyContent="flex-start"
                        >
                            {navigationRoutes.map((navigationItem, index) => {
                                const {label, route, children} = navigationItem;

                                return (
                                    <MobileNavigationItem
                                        key={index}
                                        children={children}
                                        handleNavigationMenuToggle={
                                            handleNavigationMenuToggle
                                        }
                                        handleSubMenuToggle={
                                            handleSubMenuToggle
                                        }
                                        handleSubMenuCloseClick={
                                            handleSubMenuCloseClick
                                        }
                                        handleMenuItemClick={
                                            handleMenuItemClick
                                        }
                                        isSubMenuOpen={isSubMenuOpen}
                                        label={label}
                                        route={route}
                                    />
                                );
                            })}
                            <Divider />
                            <MobileUserMenu
                                isOpen={isAccountMenuOpen}
                                handleAccountMenuToggle={
                                    handleAccountMenuToggle
                                }
                                onSubMenuToggle={handleSubMenuCloseClick}
                            />
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </DrawerContainer>
        </>
    );
};

MobileNavigationMenu.propTypes = {
    handleNavigationMenuToggle: PropTypes.func.isRequired,
    isNavigationMenuOpen: PropTypes.bool.isRequired,
    navigationRoutes: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            route: PropTypes.string,
            paths: PropTypes.arrayOf(PropTypes.string),
            children: PropTypes.arrayOf(
                PropTypes.shape({
                    heading: PropTypes.string.isRequired,
                    submenu: PropTypes.arrayOf(
                        PropTypes.shape({
                            label: PropTypes.string.isRequired,
                            route: PropTypes.string.isRequired,
                            paths: PropTypes.arrayOf(PropTypes.string),
                            subtitle: PropTypes.string,
                            isDisabled: PropTypes.bool,
                        })
                    ),
                })
            ),
        })
    ).isRequired,
};

export default MobileNavigationMenu;
